import { Component, OnInit, ViewChild } from '@angular/core';
import { DxHtmlEditorComponent, DxTextBoxComponent, DxTextBoxModule } from 'devextreme-angular';
import { Observable, Subject } from 'rxjs';
import { NgIf } from '@angular/common';

@Component({
    selector: 'al-link-edit-title-modal',
    templateUrl: './link-edit-title-modal.component.html',
    styleUrls: ['./link-edit-title-modal.component.scss'],
    standalone: true,
    imports: [NgIf, DxTextBoxModule],
})
export class LinkEditTitleModalComponent implements OnInit {
	@ViewChild(DxTextBoxComponent)
	textBox: DxTextBoxComponent;

	public showDialog: boolean = false;
	private originalTitle: string;
	public currentTitle: string;

	result$: Subject<string>;

	constructor() {}

	ngOnInit(): void {}

	public show(originalTitle: string = null): Observable<string> {
		this.result$ = new Subject<string>();

		if (originalTitle !== null && originalTitle.length > 0) this.originalTitle = originalTitle;
		else this.originalTitle = 'No title was given';
		this.currentTitle = this.originalTitle;
		this.showDialog = true;

		return this.result$.asObservable();
	}

	public cancel(): void {
		this.result$.complete();
		this.showDialog = false;
	}

	public save(): void {
		this.result$.next(this.textBox.value);
		this.result$.complete();
		this.showDialog = false;
	}
}
